import { client } from 'shared';

export function getHourReports(pageNumber?: number) {
    return client(`api/hour-report/?page=${pageNumber ? pageNumber : 1}`);
}

export function getHourReport(id: number) {
    return client(`api/hour-report/${id}/`);
}
